export default {"src":"/_next/static/media/mobile_consultunt_img_04.317d1cde.svg","height":140,"width":300};